<template>
	<div>
		<v-btn
			color="info"
			v-if="active"
			small
			@click="deactivate()"
			:loading="loading"
		>
			{{ $t("label.active") }}</v-btn
		>
		<v-btn
			color="error"
			v-else
			small
			@click="activate()"
			:loading="loading"
			>{{ $t("label.inactive") }}</v-btn
		>
	</div>
</template>

<script>
export default {
	props: ["value", "endpoint"],

	data() {
		return {
			active: this.value,
			loading: false,
		};
	},

	methods: {
		activate() {
			this.loading = true;
			try {
				this.$inertia.post(
					this.endpoint,
					{
						active: true,
					},
					{
						preserveScroll: true,
						onSuccess: () => (this.active = true),
						onProgress: (progress) => (this.loading = progress),
					}
				);
			} finally {
				this.loading = false;
			}
		},

		deactivate() {
			this.loading = true;
			try {
				this.$inertia.post(
					this.endpoint,
					{
						active: false,
					},
					{
						preserveScroll: true,
						onSuccess: () => (this.active = false),
						onProgress: (progress) => (this.loading = progress),
					}
				);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>